import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (param) {
  const { data, exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'GET_PRODUCT_SUBITEM',
    manual: false,
  });

  useEffect(() => {
    if (param['parent_id']) {
      let url = '/api/product_subitem';
      let arr = [];
      Object.keys(param).forEach(key => {
        arr.push(key + '=' + param[key]);
      });
      if (arr.length !== 0) {
        url += '?' + arr.join('&');
      }
      exec(url);
    }
  }, [param]);
  return [data || [], exec, isRequestSuccessed];
});
